import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FilterItem, FilterType, InputType, PagingOptions, TagsInputOptions, TextBoxOptions } from 'bbsf-controls';
import { SectorModel } from '../../shared/models/SectorModels/SectorModel';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ActivatedRoute } from '@angular/router';
import { DataSecretService } from '../../shared/Services/data.service';
import { SectorService } from '../../shared/Services/SectorService.service';
import { SectorDepartmentModel } from '../../shared/models/SectorModels/SectorDepartmentModel';
import { PageInfoService } from '../../../_metronic/core/services/page-info.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService, UtilityService, BBSFTranslateService, EnvironmentService } from 'bbsf-utilities';

@Component({
  selector: 'lib-sector-info',
  templateUrl: './sector-info.component.html'
})
export class SectorInfoComponent implements OnInit {
  SubheaderTitle : string;
  ShowToolbar = true;
  ShowbreadCrumb = true;
  BreadcrumbTitle = this.utilityService.getResourceValue('Sectors');
  Url="/Admin/Sectors/Sector"
  ApiUrl = "/api/admin/Sector/"
  searchTextBox: TextBoxOptions;
  SectorIdTextBox: TextBoxOptions;
  filterForm = new FormGroup({});
  DepartmentSectorForm = new FormGroup({});
  showFilter: boolean = false;
  DepartmentSectorPagingResult: any[] = [];
  DepartmentSectorPaging: PagingOptions;
  TextInputFilter: FilterItem;
  SectorIdTextInputFilter: FilterItem;
  IsFilterLoaded: boolean = false;
  AuthToken: string = ""
  SectorId: string = ""
  PageName:string=""
  Sector:SectorModel=new SectorModel();
  @ViewChild('UserDepartmentSectorPagingViewElement', { static: false }) input: ElementRef;
  // Decorator wires up blockUI instance
  @BlockUI() blockUI: NgBlockUI;
  ShowPageContent:boolean=false;

  //Add Model Controls
  AddDepartmentToSectorForm = new FormGroup({});
  DepartmentAutoComplete: TagsInputOptions;
  IsAddDepartmentFormLoaded: boolean;
  @ViewChild('CloseAddDepartmentToSector', { static: false }) CloseAddDepartmentToSector: ElementRef;
  language:string=""

  //delete  Model Controls
  deleteDepartmentId: number;
  IsOpenDeleteDepartmentFromSectorModal: boolean = false
  @ViewChild('CloseDeleteDepartmentFromSectorModal', { static: false }) CloseDeleteDepartmentFromSectorModal: ElementRef;

  constructor(private authService: AuthService,public utilityService:UtilityService,private bbsfTranslateService:BBSFTranslateService,private environmentService:EnvironmentService,private activatedRoute: ActivatedRoute, private dataServices: DataSecretService, private sectorService: SectorService, private pageInfoService: PageInfoService, private modalService: NgbModal) {
    this.activatedRoute.params.subscribe(params => {
      this.SectorId = params['id'];
     localStorage.setItem("SectorId",this.SectorId);

    });
  }
  async ngOnInit(): Promise<void> {
    this.ShowPageContent=true;
    this.bbsfTranslateService.onLangChange.subscribe((event)=>{
      this.ShowPageContent=false;
      this.language = event.lang;
      this.ngOnInit();
    })
    this.language =  await this.utilityService.getCurrentLanguage();
    this.LoadUserList();
  
  }

  ReinitializeDepartmentSectorPaging() {
    let element = this.input as any;
    element.ReinitializePaging();
  }

  UpdateDepartmentSectorPaging() {
    let element = this.input as any;
    element.UpdatePaging();
  }

  setDepartmentSectorListResult(result) {
    this.DepartmentSectorPagingResult = result
    this.ShowPageContent=true;
    this.utilityService.stopBlockUI()
  }

  resetFilters() {
    this.DepartmentSectorForm.controls["searchTextBox"].setValue(null);
    let element = this.input as any;
    element.ReinitializePaging();
  }

  LoadUserList() {
    this.sectorService.GetSectorInfo(this.SectorId).subscribe((result) => {
      this.IsFilterLoaded=false
      let resultModel= result as any
       //console.log(resultModel.val);
      this.Sector.Name.English= resultModel.val.name.english;
      this.Sector.Name.Arabic= resultModel.val.name.arabic;
      this.SubheaderTitle = this.language == "en" ? this.Sector.Name.English : this.Sector.Name.Arabic;
      PageInfoService.PageTitle=this.SubheaderTitle 
      PageInfoService.PageBreadcrumbs=[
         {title: this.utilityService.getResourceValue("Home") , path: '/Admin/Home', isSeparator: false, isActive: false},
         {title: '', path: '', isSeparator: true, isActive: false},
         {title: this.utilityService.getResourceValue("Sectors") , path: '/Admin/Sectors/Sector', isSeparator: false, isActive: false},
         {title: '', path: '', isSeparator: true, isActive: false}
    
      ]; 

      this.pageInfoService.calculateTitle();
      this.pageInfoService.calculateBreadcrumbs();


    // TextBox inti
    this.searchTextBox = new TextBoxOptions();
      this.searchTextBox.Name = "searchTextBox"
      this.searchTextBox.HideLabel = true
    this.searchTextBox.Type = InputType.Text
      this.searchTextBox.Placeholder = this.utilityService.getResourceValue("SearchByName")

    this.SectorIdTextBox = new TextBoxOptions();
    this.SectorIdTextBox.Name = "SectorIdTextBox"
      this.SectorIdTextBox.HideLabel = true
    this.SectorIdTextBox.Type = InputType.Text
    this.SectorIdTextBox.Value = this.SectorId;

    this.TextInputFilter = new FilterItem();
    this.TextInputFilter.FormControlName = "searchTextBox"
    this.TextInputFilter.ActionParameterName = "searchText"
    this.TextInputFilter.IsFormControl = true
    this.TextInputFilter.FilterType = FilterType.TextBox

    this.SectorIdTextInputFilter = new FilterItem();
    this.SectorIdTextInputFilter.FormControlName = "SectorIdTextBox"
    this.SectorIdTextInputFilter.ActionParameterName = "SectorId"
    this.SectorIdTextInputFilter.IsFormControl = true
    this.SectorIdTextInputFilter.FilterType = FilterType.TextBox

    this.DepartmentSectorPaging = new PagingOptions();
    this.DepartmentSectorPaging.ActionPostURL = this.environmentService.getApiUrl() + this.ApiUrl + 'GetDepartmentsByFilter';
    this.DepartmentSectorPaging.OnKeyPressFiltersControlNames = ["searchTextBox", "SectorIdTextBox"]
    this.DepartmentSectorPaging.Filters = [this.TextInputFilter, this.SectorIdTextInputFilter]
    this.DepartmentSectorPaging.ValidationToken = this.authService.authorizationHeaderValue()
    this.IsFilterLoaded = true;
     
  });
  }



  showAddDepartmentToSectorModal(AddDepartmentToSectorModal) {
    this.utilityService.startBlockUI();
    this.AddDepartmentToSectorForm = new FormGroup({})

    this.DepartmentAutoComplete = new TagsInputOptions();
    this.DepartmentAutoComplete.Name = "DepartmentAutoComplete";
    this.DepartmentAutoComplete.LabelKey = "Departments";
    this.DepartmentAutoComplete.IsRequired = true;
    this.DepartmentAutoComplete.Value = null;
    this.DepartmentAutoComplete.ActionURL = this.environmentService.getApiUrl() + this.ApiUrl + "AutoCompleteDepartmentList"
    this.DepartmentAutoComplete.ValidationToken = this.AuthToken
    this.DepartmentAutoComplete.CanDeleteTags = true
    this.modalService.open(AddDepartmentToSectorModal);
    this.utilityService.stopBlockUI();

  }

  addDepartmentToSector() {
    if (this.AddDepartmentToSectorForm.invalid) {
      return;
    }
    else {
      let ResultModel = this.AddDepartmentToSectorForm.value;
      let AddModel:SectorDepartmentModel= new SectorDepartmentModel() ;
      for (let index = 0; index < ResultModel.DepartmentAutoComplete.length; index++) {
        const key = ResultModel.DepartmentAutoComplete[index].key;
        AddModel.DepartmentIDs.push(Number(key))
        
      }
      AddModel.SectorID=Number(this.SectorId);
      this.sectorService.AddDepartmentsToSector(AddModel).subscribe((result) => {
        this.modalService.dismissAll();
        let element = this.input as any;
        element.ReinitializePaging();
      }, (error) => {
      
      })
    }
  }


  showDeleteDepartmentFromSectorModal(department: any, deleteDepartmentModal) {
    this.deleteDepartmentId = department.id
    this.utilityService.startBlockUI();
    this.modalService.open(deleteDepartmentModal);
    this.utilityService.stopBlockUI();


  }

  deleteDepartmentFromSector() {
    this.sectorService.DeleteDepartmentFromSector(this.deleteDepartmentId.toString()).subscribe((result) => {
      this.deleteDepartmentId = 0;
      this.modalService.dismissAll();
      let element = this.input as any;
      element.ReinitializePaging();
    }, (error) => {
    
    })
  }



}
